export default __webpack_public_path__ + "images/46_thumbnail.jpg";